export default "__VITE_ASSET__BDlj5I9___"